import { render, staticRenderFns } from "./HeaderNavigationList.vue?vue&type=template&id=540d7f38&"
import script from "./HeaderNavigationList.vue?vue&type=script&lang=js&"
export * from "./HeaderNavigationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderNavigationLink: require('/srv/rir-platform/tourism/src/tourism-front/components/common/HeaderNavigation/HeaderNavigationLink.vue').default})
